/**
 * Atlas SPA entry point.
 *
 * Wires the Firebase-backed side effects (bootstrap.ts) and mounts <App />.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { onLCP, onINP, onCLS } from 'web-vitals';
import { App } from './views/App.js';
import { bootstrapAtlas, appActions } from './bootstrap.js';
import { wireWebVitals } from './perf/webVitals.js';
import './styles.css';

bootstrapAtlas();
// PERF-06 — surface Core Web Vitals via structured console.info; Hosting log
// forwarding aggregates them. Pipe to BigQuery lands with the SLO dashboard.
wireWebVitals(undefined, { onLCP, onINP, onCLS });

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Atlas: #root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <App actions={appActions} />
  </StrictMode>,
);
